"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var identifiers_1 = require("../identifiers");
var react_css_themr_1 = require("@vidazoo/react-css-themr");
var formField_1 = require("../formField");
var MultiSelect_1 = require("./MultiSelect");
var Group_1 = require("./Group");
var Option_1 = require("./Option");
var theme = require("./theme.scss");
var ThemedMultiSelect = react_css_themr_1.themr(identifiers_1.MULTI_SELECT, theme)(MultiSelect_1.default);
exports.MultiSelect = ThemedMultiSelect;
var ThemedMultiSelectGroup = react_css_themr_1.themr(identifiers_1.MULTI_SELECT_GROUP, theme)(Group_1.default);
exports.MultiSelectGroup = ThemedMultiSelectGroup;
var ThemedMultiSelectOption = react_css_themr_1.themr(identifiers_1.MULTI_SELECT_OPTION, theme)(Option_1.default);
exports.MultiSelectOption = ThemedMultiSelectOption;
ThemedMultiSelect.displayName = "MultiSelect";
ThemedMultiSelectGroup.displayName = "MultiSelectGroup";
ThemedMultiSelectOption.displayName = "MultiSelectOption";
var FormMultiSelect = formField_1.default(ThemedMultiSelect);
exports.FormMultiSelect = FormMultiSelect;
ThemedMultiSelect.displayName = "MultiSelect";
ThemedMultiSelectGroup.displayName = "MultiSelectGroup";
ThemedMultiSelectOption.displayName = "MultiSelectOption";
exports.default = ThemedMultiSelect;
